<template>
  <b-button
    :title="title"
    :type="isOn ? 'is-dark' : ''"
    class="has-text-weight-bold"
    :class="{ 'matrix-column-button': !isOn, [code.code]: true }"
    :disabled="disabled"
    :loading="toggling"
    @click="toggle_"
  >
    {{ code.code }}
  </b-button>
</template>

<script>
export default {
  props: {
    code: {
      type: Object,
      required: true
    },
    isOn: {
      type: Boolean,
      default: false
    },
    toggle: {
      type: Function,
      required: true
    }
  },
  data: () => ({
    toggling: false
  }),
  computed: {
    title() {
      return `TYPE: ${this.code.type} | CODE: ${this.code.code} | NAME: ${
        this.code.name
      } | GROUP: ${this.code.group || "N/A"}`;
    },
    disabled() {
      return !this.code.status;
    }
  },
  methods: {
    async toggle_() {
      this.toggling = true;

      try {
        await this.toggle();

        this.$buefy.toast.open({
          message: "Codes has been associated.",
          type: "is-info",
          position: "is-top-right"
        });
      } catch (err) {}

      this.toggling = false;
    }
  }
};
</script>

<style scoped>
.matrix-column-button:hover {
  background-color: #363636;
  border-color: #363636;
  color: whitesmoke;
}
.matrix-column-button[disabled]:hover {
  border-color: inherit;
  background-color: inherit;
  color: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/CodesMatrixManager/partials/matrixColumn.vue